import { render } from "./DGroup.vue?vue&type=template&id=8f2142b8&scoped=true&ts=true"
import script from "./DGroup.vue?vue&type=script&lang=ts"
export * from "./DGroup.vue?vue&type=script&lang=ts"

import "./DGroup.vue?vue&type=style&index=0&id=8f2142b8&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2142b8"]])

export default __exports__